define.alias("shared/components/shared/credentials/tiktok-refresh-confirm", "preview-grid/components/shared/credentials/tiktok-refresh-confirm");